import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareInboxNextGenRoute: InvariantJiraRoute = {
	name: 'inbox',
	path: '/jira/software/projects/:projectKey/inbox/:issueKey?',
};
